import React, { useContext, useMemo } from 'react';
import {
    EntityValidations,
    ISpecificEntityFormProps,
    IPPVision,
    PPVision
} from '../../types';
import styles from '../../styles/cr.module.scss';
import { CrTextField } from '../cr/CrTextField';
import { EntityForm } from '../EntityForm';
import { DataContext } from '../DataContext';
import { CrCheckbox } from '../cr/CrCheckbox';

export class PPVisionValidations extends EntityValidations {

}

export const PPVisionForm = (props: ISpecificEntityFormProps): React.ReactElement => {
    const { dataServices, lookupData, loadLookupData: { customFieldDfns, entityStatuses, projects, userProjects, users: { all: allUsers } } } = useContext(DataContext);

    useMemo(() => customFieldDfns(), [customFieldDfns]);
    useMemo(() => entityStatuses(), [entityStatuses]);
    useMemo(() => projects(), [projects]);
    useMemo(() => userProjects(), [userProjects]);
    useMemo(() => allUsers(), [allUsers]);

    const validateEntity = (vision: IPPVision): Promise<PPVisionValidations> => {
        const errors = new PPVisionValidations();

        if (vision.Title === null || vision.Title === '') {
            errors.Title = 'Vision Title is required';
            errors.Valid = false;
        }
        else
            errors.Title = null;



        return Promise.resolve(errors);
    };

    return (
        <EntityForm<IPPVision, PPVisionValidations>
            {...props}
            entityName="Vision"
            renderFormFields={(changeHandlers, formState) => {
                const { FormData: vision, ValidationErrors: errors } = formState;

                return (
                    <div>
                        <CrTextField
                            label="Title"
                            required={true}
                            maxLength={255}
                            className={styles.formField}
                            value={vision.Title}
                            onChange={(_, v) => changeHandlers.changeTextField(v, 'Title')}
                            errorMessage={errors.Title}
                        />
                        <CrTextField
                            label="Description"
                            className={styles.formField}
                            value={vision.Description}
                            rows={10}
                            maxLength={5000}
                            onChange={(_, v) => changeHandlers.changeTextField(v, 'Description')}
                            multiline
                        />
                        <CrCheckbox
                            className={`${styles.formField} ${styles.checkbox}`}
                            label="Is Current Vision"
                            checked={vision.CurrentVision}
                            onChange={(_, isChecked) => changeHandlers.changeCheckbox(isChecked, 'CurrentVision')}
                        />

                    </div>
                );
            }}
            loadEntity={id => dataServices.ppVisionService.read(id, false, false)}
            loadNewEntity={() => new PPVision()}
            loadEntityValidations={() => new PPVisionValidations()}
            onValidateEntity={validateEntity}
            onCreate={w => dataServices.ppVisionService.create(w)}
            onUpdate={w => dataServices.ppVisionService.updatePut(w.ID, w)}
            parentEntities={dataServices.ppVisionService.parentEntities}
        // childEntities={[
        //     { ObjectParentProperty: 'Contributors', ParentIdProperty: 'WorkStreamID', ChildIdProperty: 'ContributorUserID', ChildService: dataServices.contributorService },
        //     { ObjectParentProperty: 'CustomFields', ParentIdProperty: 'WorkStreamID', ChildIdProperty: 'CustomFieldDefnID', ChildService: dataServices.customFieldService }
        // ]}
        />
    );
};
